import { render, staticRenderFns } from "./SupportBox.vue?vue&type=template&id=4cacee44"
import script from "./SupportBox.vue?vue&type=script&lang=js"
export * from "./SupportBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports